import 'core-js/stable'
import 'core-js/modules/es.object.get-own-property-descriptors'
import 'regenerator-runtime/runtime'
import 'intersection-observer'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n, { t, setLocale, getLocale } from './i18n'
import { oss } from './utils/oss'
import './assets/custom.css'

Vue.config.productionTip = false
Vue.prototype.$t = t
Vue.prototype.$setLocale = setLocale
Vue.prototype.$getLocale = getLocale
Vue.prototype.$i18nState = i18n.localeState
Vue.prototype.$oss = oss

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
